import Api from '../Api';

import { url } from './config';
import { EmailSettings } from './types';

const api = new Api<EmailSettings>(url);

export default api;
